import React, { useState } from "react";
import "./FAQPage.css";

const faqs = [
 {
    question: "Is Aadhaar Card compulsory to attend Private Party & VR Gaming?",
    answer: "Yes, carrying your Aadhaar Card or any valid government ID is compulsory for entry verification and security purposes. This helps us ensure a safe and smooth gaming experience for all participants."
  },
  {
    question: "Which movies or shows can we watch? Can we play our own videos?",
    answer:
      "Guests can connect their OTT accounts or use The HexaPlay’s OTT subscriptions to stream any content of their choice. Laptops and pendrives are also supported for streaming so you can enjoy your favorite movies, shows, or personal videos without hassle."
  },
  {
    question: "What is the refund policy?",
    answer:
      "You will receive a full refund of your advance payment if the booking is cancelled at least 72 hours before the scheduled slot."
  },
  {
    question: "Are washrooms available?",
    answer:
      "Yes. The HexaPlay provides clean and hygienic washroom facilities for all guests."
  },
  {
    question: "Are kids chargeable?",
    answer:
      "Kids above 10 years are fully chargeable. Kids aged between 3 and 10 years are charged half the rate, and kids below 3 years enjoy free entry."
  },
  {
    question: "What if there’s a technical interruption?",
    answer:
      "If there is any failure in the projector, laptop, internet, or sound system, the affected portion will be refunded after deducting the rent for the uninterrupted period."
  },
  {
    question: "Are we responsible for our belongings?",
    answer:
      "Guests are responsible for their personal items. The HexaPlay is not liable for any loss or damage."
  },
  {
    question: "Does the booking time include setup and check-out?",
    answer:
      "Yes. Guests must vacate the theatre with all belongings at or before the end of the booked time."
  },
  {
    question: "Can we change the configuration of technical equipment?",
    answer:
      "No. Changes should not be made to the projector, screen, laptop, or sound system. Our team will handle any adjustments if required."
  },
  {
    question: "Are couples below 18 allowed?",
    answer:
      "No. Aadhaar Card or Driving License verification is required for bookings. Minor group bookings are allowed, but underage couples are not permitted."
  },
  {
    question: "Who is liable for damages?",
    answer:
      "Guests are responsible for any damage caused to theatre equipment, furniture, lights, walls, or other items and must pay for repairs."
  },
  {
    question: "Is there a cleaning fee?",
    answer:
      "A cleaning fee up to ₹1000 may apply if significant cleaning is required after checkout including garbage, leftovers, or spills."
  },
  {
    question: "Are there restrictions on consumption?",
    answer:
      "Smoking, alcohol, and illegal substances are strictly prohibited inside the theatre. Violators will face appropriate action."
  },
  {
    question: "Are pets allowed?",
    answer:
      "No. Pets are strictly not allowed inside the theatre."
  },
  {
    question: "What about photography and fog entry?",
    answer:
      "Photoshoots and Fog Entry can be added online during booking or requested on the day of your celebration."
  },
  {
    question: "Are the seats recliners?",
    answer:
      "Small theatres (up to 4 seats) include full recliners. Larger theatres (more than 4 seats) include comfortable sofa seating."
  },
  {
    question: "What about food and beverages? Can we bring outside food?",
    answer:
      "The HexaPlay provides a variety of food and beverage options for guests. Outside food and beverages are not permitted."
  },
  {
    question: "Are decorations customizable?",
    answer:
      "Decorations follow the designs shown on our website. Essential customization like Neon Lights, LED Name Boards, and themed setups will be arranged according to your occasion."
  }
];

export default function FAQPage() {

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-page">

      <div className="faq-header">
        <h1>Frequently Asked Questions</h1>
        <p>
          Have doubts? Check out our FAQs below.  
          If you still have questions, feel free to contact us at  
          <strong> 9087775659</strong>.
        </p>
      </div>

      <div className="faq-container">

        {faqs.map((faq, index) => (
          <div
            className={`faq-card ${activeIndex === index ? "active" : ""}`}
            key={index}
          >

            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
              <span>{activeIndex === index ? "−" : "+"}</span>
            </button>

            <div className="faq-answer">
              <p>{faq.answer}</p>
            </div>

          </div>
        ))}

      </div>

      <div className="faq-contact">
        <h3>Still have questions?</h3>
        <a href="tel:9087775659" className="contact-btn">
          Call Us Now
        </a>
      </div>

    </div>
  );
}